import {
    COMMON_VALUES,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    SWITCH_LANGUAGE,
    SET_MEMBERSHIP,
    PIN_CODE_VALID,
    SOCKET_MODAL,
    CLEAR_PINCODE,
    MODEL_DATA,
    COUNT_DATA,
} from './commonTypes'

export default (state, action) => {
    switch (action.type) {
        case COMMON_VALUES:
            return {
                ...state,
                ...action.payload,
            }
        case SOCKET_MODAL:
            return {
                ...state,
                socketModal: !state.socketModal,
            }
        case SWITCH_LANGUAGE:
            return {
                ...state,
                currentLanguage: action.payload,
            }
        case PIN_CODE_VALID:
            return {
                ...state,
                pinCodeData: action.payload,
            }
        case COUNT_DATA:
            return {
                ...state,
                statics_count: action.payload,
            }
        case CLEAR_PINCODE:
            return {
                ...state,
                pinCodeData: null,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case SET_MEMBERSHIP:
            return {
                ...state,
                ...action.payload,
            }
        case MODEL_DATA:
            return {
                ...state,
                modelStatus: action.payload.modelStatus,
            }
        default:
            return state
    }
}
